import { ChangeEvent, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { alpha, type Theme } from '@mui/material/styles';
import { filledButtonSx } from '../shared/buttonStyles';

export type CashdeskPanel = 'offer' | 'text' | null;

interface CashdeskToolbarProps {
  openPanel: CashdeskPanel;
  onTogglePanel: (panel: Exclude<CashdeskPanel, null>) => void;
  onInsertField: () => void;
  onImage: (dataUrl: string) => void;
}

function CashdeskToolbar({ openPanel, onTogglePanel, onInsertField, onImage }: CashdeskToolbarProps) {
  const imageInputRef = useRef<HTMLInputElement>(null);
  const buttonSx = filledButtonSx();
  const panelButtonSx = (panel: CashdeskPanel) => ({ ...buttonSx, backgroundColor: openPanel === panel ? (theme: Theme) => alpha(theme.palette.primary.main, 0.87) : 'primary.main' });

  const handleImageFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') onImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <Box sx={{ border: '1px solid', borderColor: 'grey.200', borderRadius: 2, p: 2, mb: 2, backgroundColor: 'background.paper' }}>
      <Typography variant="body2" fontWeight={700} sx={{ mb: 1.5, color: 'text.primary', display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <span style={{ fontSize: '0.95rem' }}>🔧</span> Outils
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Button variant="contained" size="small" startIcon={<QrCode2Icon fontSize="small" />} onClick={() => onTogglePanel('offer')} sx={panelButtonSx('offer')}>
          Code opération
        </Button>
        <Button variant="contained" size="small" startIcon={<PersonAddAltIcon fontSize="small" />} onClick={onInsertField} sx={buttonSx}>
          Champ de Personnalisation
        </Button>
        <Button variant="contained" size="small" startIcon={<TextFieldsIcon fontSize="small" />} onClick={() => onTogglePanel('text')} sx={panelButtonSx('text')}>
          Zone de texte
        </Button>
        <Button variant="contained" size="small" startIcon={<PhotoLibraryIcon fontSize="small" />} onClick={() => imageInputRef.current?.click()} sx={buttonSx}>
          Insérer une image
        </Button>
        <input ref={imageInputRef} type="file" accept="image/*" hidden onChange={handleImageFileChange} />
      </Box>
    </Box>
  );
}

export default CashdeskToolbar;
